export enum NewResourceQueryParamKey {
  TENANT = 'tenant',
}
